import {createTypes, async} from 'redux-action-creator'

export default {
  ...createTypes([
    ...async('VALIDATE_CODE_AND_GET_DEPOSIT'),
    ...async('SAVE_CARD')
    ],
  'CREDIT_CARD_CODE/',
  ),
  SET_CARD_NUMBER: 'CREDIT_CARD_CODE/SET_CARD_NUMBER',
  SET_CARD_EXPIRY: 'CREDIT_CARD_CODE/SET_CARD_EXPIRY',
  SET_CARD_CVC: 'CREDIT_CARD_CODE/SET_CARD_CVC',
  SET_CARDHOLDER_NAME: 'CREDIT_CARD_CODE/SET_CARDHOLDER_NAME',
  SET_DOCUMENT_TYPE: 'CREDIT_CARD_CODE/SET_DOCUMENT_TYPE',
  SET_DOCUMENT_NUMBER: 'CREDIT_CARD_CODE/SET_DOCUMENT_NUMBER',
  SET_CARD_TYPE: 'CREDIT_CARD_CODE/SET_CARD_TYPE',
}



// WEBPACK FOOTER //
// ./src/sections/addCreditCard/types/addCreditCard.js